/* facts-label-branded.js
   ---------------------------------------------------------------------------
   Keeps the Nutrition / Supplement Facts panel in step with the selected variant.

   Dawn's product-info.js re-fetches the whole product section for every variant
   change (`?variant=<id>&section_id=<section>`), parses it into a Document, and
   publishes `variant-change` with `{ data: { sectionId, html, variant } }`. It only
   swaps a fixed list of ids (price, sku, inventory...). This script adds one more:
   `#FactsLabel-<sectionId>`, so servings-per-container is re-rendered by Liquid,
   the single source of truth, instead of being recomputed in JavaScript.

   Loaded with `defer` from snippets/product-facts-label-branded.liquid, so it runs
   after constants.js and pubsub.js (both deferred earlier in <head>).
   --------------------------------------------------------------------------- */
(function () {
  if (window.__frcFactsLabelBound) return;
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  window.__frcFactsLabelBound = true;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.html || !data.sectionId) return;

    var id = 'FactsLabel-' + data.sectionId;
    var source = data.html.getElementById(id);
    var target = document.getElementById(id);
    if (!source || !target) return;

    target.innerHTML = source.innerHTML;
  });
})();
